import moment from "moment";

const getElapsedTime = (job: IDataObjectsDuplicateJob): React.ReactNode => {
    if (job.startedDate && job.completedDate) {
        const startDate = moment.utc(job.startedDate);
        const completedDate = moment.utc(job.completedDate);
        const duration = moment.duration(completedDate.diff(startDate));
        const displayValue = moment.utc(duration.as("milliseconds")).format("HH:mm:ss");
        return displayValue;
    }
    return "";
};

export default getElapsedTime;
